import React, {Fragment, useEffect, useState} from "react";
import {Col, Container, Row} from "react-bs4grid";
import {Link, withRouter} from "react-router-dom";

import useAppState from "../../common/StateMachine/useAppState";
import axiosInstance from "../../apiPromises/axiosInstance";
import AppContainer from "../AppContainer/AppContainer";
import Button from "../../common/Button/Button";

import "./job-delivery.scss";
import {InfoCard} from "../Reusable/InfoCard";
import {useTranslation} from "react-i18next";

function JobDelivery({match, history}) {
    const jobsState = useAppState("jobs");
    const accountState = useAppState("account");
    const [t] = useTranslation();

    const account = accountState.state;
    const jobDetail = jobsState.state.jobDetail;
    const [userProfile, setUserProfile] = useState({});

    useEffect(() => {
        jobsState.getJob(match.params.jobId);
        axiosInstance.get("/users/current").then(res => {
            setUserProfile(res.data);
        });
    }, []);

    return (
        <AppContainer>
            {account && userProfile.userId && jobDetail.id && (
                <Fragment>
                    <Container className="pb-16">
                        <Row className="pt-32" justifyContent="center" alignItems="center">
                            <Col style={{display: "flex", justifyContent: "center"}}>
                                <div className="job-details-content">
                                    <h1 style={{marginBottom: "10px"}}>{t("readyToDeliver")}</h1>
                                    <h3>{t("deliverToHub")}</h3>
                                </div>
                            </Col>
                        </Row>
                        {/*QR Code disabled for now*/}
                        {/*<Row>*/}
                        {/*  <Col style={{ display: "flex", justifyContent: "center" }}>*/}
                        {/*    <div className="profile-qr-code-section pt-32 pb-16">*/}
                        {/*      <div className="profile-qr-code-wrapper">*/}
                        {/*        <img src={userProfile.qrCodeImagePath} alt="icon profile" />*/}
                        {/*      </div>*/}
                        {/*    </div>*/}
                        {/*  </Col>*/}
                        {/*</Row>*/}
                    </Container>
                    <div className="jobs-list-container pad-top justify-center">
                        <h4>{t("collectorDetail")}</h4>

                        {/*User Photo and Name*/}
                        <div className="details-center-container">
                            <div className="job-delivery-detail-card extra-padding">
                                <div className="avatar-wrapper">
                                    <img className="user-avatar"
                                         src={userProfile.profilePhotoPath || "/icon-profile.svg"}
                                         alt="icon profile"/>
                                </div>
                                <div className="user-name">{userProfile.fullName}</div>
                            </div>
                        </div>

                        {/*User Id*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("authorizedPlastXNumber")}:`}
                                      description={`${userProfile.userId}`}/>
                        </div>
                        <Row className="hubs-list pt-16" justifyContent="center" alignItems="center">
                            <Col w="auto">
                                <h4>{t("deliveryLocations")}</h4>
                            </Col>
                        </Row>
                        {
                            jobDetail.assignedSites.map((site, index) => <div className="details-center-container"><InfoCard title={`Hub #${index}`} description={`${site.address.fullAddress}`}></InfoCard></div>)
                        }
                        <Row className="jobs-list pt-16"
                             justifyContent="center"
                             alignItems="center">
                            <Col w="auto">
                                <h4>{t("jobDetail")}</h4>
                            </Col>
                        </Row>

                        {/*Job Number*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("jobId")}:`}
                                      description={`#${jobDetail.id}`}/>
                        </div>

                        {/*Plastic Type*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("plasticType")}:`}
                                      description={t(jobDetail.plasticType.name)}/>
                        </div>

                        {/*Colour*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("colour")}:`}
                                      description={t(jobDetail.plasticColourName)}/>
                        </div>

                        {/*Other Details*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("otherDetails")}:`}
                                      description={(jobDetail.otherDetails != null) ? t(jobDetail.otherDetails) : ""}/>
                        </div>

                        {/*Colour*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("cleaned")}:`}
                                      description={jobDetail.cleaned ? t("yes") : t("no")}/>
                        </div>

                        {/*Minimum Collection*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("minimumCollectionAmount")}:`}
                                      description={`${jobDetail.minCollection}Kg`}/>
                        </div>

                        {/*Expected Amount*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("quantityKg")}:`}
                                      description={`${jobDetail.userCommitment.totalAmountCommitted}Kg`}/>
                        </div>

                        {/*Price*/}
                        <div className="details-center-container">
                            <InfoCard title={`${t("price")}:`}
                                      description={`${t('$')}${jobDetail.pricePerKg.toFixed(2)}/ Kg`}/>
                        </div>

                        <div className="flex justify-center align-center">
                            <div>
                                <Link to="/jobs/my-jobs/">
                                    <Button className="mt-32 mb-32" text={t("done")}/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )}
        </AppContainer>
    );
}

export default withRouter(JobDelivery);
